import { css } from "@emotion/css";
import { $, type Properties, resolve } from "signlets";

import { classes } from "./classes";

const style = css`
  padding: 1rem;
  backdrop-filter: grayscale(75%) contrast(75%) brightness(50%) blur(0.25rem);
  -webkit-backdrop-filter: grayscale(75%) contrast(75%) brightness(50%)
    blur(0.25rem);
  border-radius: 0.25rem;
  opacity: 0;
  transition: opacity 200ms;

  &.visible {
    opacity: 1;
  }

  &.border {
    border: 2px solid white;
  }
`;

export type OverlayProps = {
  visible?: boolean;
  border?: boolean;
  ["class"]?: string;
  children?: JSX.Element;
};

export const Overlay = ({
  visible = true,
  border = false,
  ["class"]: _class,
  children,
}: Properties<OverlayProps>) => (
  <div
    class={$(() =>
      classes(
        style,
        resolve(visible) && "visible",
        resolve(border) && "border",
        resolve(_class),
      ),
    )}
    inert={$(() => !resolve(visible))}
  >
    {children}
  </div>
);
